import { documentHasElements } from "modules/dom";
import "./scroll-container-block.scss";

documentHasElements(".js-scroll-container-block", (ScrollContainerBlocks) => {
    ScrollContainerBlocks.forEach((scrollContainerBlock) => {

        if (window.innerWidth > 800) {

            const sliderBlocks = scrollContainerBlock.querySelector<HTMLElement>(".slider__blocks");
            const sliderBlocksChildren = scrollContainerBlock.querySelectorAll<HTMLDivElement>(".slider__blocks > div");

            sliderBlocksChildren.forEach((block: HTMLDivElement, index: number) => {
                block.setAttribute("data-item", index.toString());
            });

            sliderBlocks?.addEventListener("wheel", (e: WheelEvent) => {
                const scrollDirection = e.deltaY > 0 ? "down" : "up";

                const activeTab = scrollContainerBlock.querySelector<HTMLElement>(".slider__content.active");
                if (!activeTab) return;

                const nextTab = activeTab.nextElementSibling as HTMLElement | null;
                const previousTab = activeTab.previousElementSibling as HTMLElement | null;

                const isAtFirst = activeTab.classList.contains("first");
                const isAtLast = activeTab.classList.contains("last");
                const isDelayed = sliderBlocks.classList.contains("delayed");

                // Prevent default scroll if within bounds
                if ((scrollDirection === "down" && !isAtLast) || (scrollDirection === "up" && !isAtFirst)) {
                    e.preventDefault();
                }

                if (isDelayed) return;

                if (scrollDirection === "down" && !isAtLast) {
                    activeTab.classList.remove("active");
                    nextTab?.classList.add("active");
                } else if (scrollDirection === "up" && !isAtFirst) {
                    activeTab.classList.remove("active");
                    previousTab?.classList.add("active");
                }

                sliderBlocks.classList.add("delayed");
                setTimeout(() => {
                    sliderBlocks.classList.remove("delayed");
                }, 500);
            }, { passive: false });

        }
    });
});